import { HealthcareFacilitySimple } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import {
   addressFormatter,
   createTranslatedText,
   useInterpolatedTranslationKey,
   useTranslate,
} from '@dreryk/react-common';
import { AutoLayout, EditIcon, Tree } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';
import { HealthcareBasicData } from '../../../common/HealthcareBasicData';
import { StyledHealthcareTreeItemText } from '../StyledHealthcareTreeItemText';
import { HealthcareFacilityUnitTreeItems } from '../unit/HealthcareFacilityUnitTreeItems';

import { HealthcareFacilityUpdateLink } from './HealthcareFacilityUpdateLink';

type HealthcareFacilityTreeItemProps = {
   readonly healthcareFacility: HealthcareFacilitySimple;
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
};

export const HealthcareFacilityTreeItem = (props: HealthcareFacilityTreeItemProps): JSX.Element => {
   const translate = useTranslate();
   const regonNumber = useInterpolatedTranslationKey(healthcareOrganizationTranslationKeys.regonNumber, {
      regonNumber: props.healthcareFacility.regon.asString(),
   });
   const address = addressFormatter(props.healthcareFacility.address);

   return (
      <Tree.Item
         testId={`healthcareFacility-${props.healthcareFacility.id}`}
         content={
            <AutoLayout
               as={'div'}
               $horizontalResizing={'fill'}
               $spacingMode={'space-between'}
               $spacing={4}
               $alignement={'center'}
            >
               <AutoLayout as={'div'} $direction={'vertical'} $spacing={4}>
                  <StyledHealthcareTreeItemText testId={'regonNumber'}>
                     {translate(regonNumber)}
                  </StyledHealthcareTreeItemText>
                  <HealthcareFacilityUpdateLink
                     testId={'name'}
                     label={createTranslatedText(props.healthcareFacility.name)}
                     healthcareFacilityId={props.healthcareFacility.id}
                     healthcareParentData={props.healthcareParentData}
                     onDataChanged={props.onDataChanged}
                  />
                  {address ? (
                     <StyledHealthcareTreeItemText testId={'address'}>{address}</StyledHealthcareTreeItemText>
                  ) : null}
               </AutoLayout>

               <HealthcareFacilityUpdateLink
                  testId={'healthcareFacilityUpdate'}
                  icon={<EditIcon />}
                  healthcareFacilityId={props.healthcareFacility.id}
                  healthcareParentData={props.healthcareParentData}
                  onDataChanged={props.onDataChanged}
               />
            </AutoLayout>
         }
      >
         <HealthcareFacilityUnitTreeItems healthcareParentData={props.healthcareFacility} />
      </Tree.Item>
   );
};
